var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M0 74h42v36H0zm42-35h77v32H42zm0-39h77v19H42z"}));
}

Logo.defaultProps = {"viewBox":"0 0 119 110"};

module.exports = Logo;

Logo.default = Logo;
